import { MouseEvent } from 'react';

import {
  Box,
  EllipsisWithTooltip,
  IconButton,
  Icons,
  Stack,
  tokens,
} from '@cast/design-system';
import { Link } from '@cast/split-me/components';
import { Cluster } from '@cast/types';

type ClusterNameCellProps = {
  cluster: Cluster;
  to: string;
};

export const ClusterNameCell = ({ cluster, to }: ClusterNameCellProps) => {
  const handleCopy = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    void navigator.clipboard?.writeText(cluster.name);
  };

  const handleLinkClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation();
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={8}
      overflow="hidden"
      minWidth={0}
      width="100%"
    >
      <IconButton
        variant="ghost"
        size="sm"
        testId="copy-cluster-name"
        aria-label="Copy cluster name"
        onClick={handleCopy}
        sx={{ flexShrink: 0 }}
      >
        <Icons.Copy size={16} />
      </IconButton>
      <Box
        component={Link}
        to={to}
        data-testid="cluster-name-link"
        onClick={handleLinkClick}
        sx={{
          minWidth: 0,
          flex: 1,
          overflow: 'hidden',
          color: tokens.theme.fg.action.primary,
          textDecoration: 'none',
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        <EllipsisWithTooltip
          TypographyProps={{
            variant: 'P12M',
            sx: { color: 'inherit' },
          }}
        >
          {cluster.name}
        </EllipsisWithTooltip>
      </Box>
    </Stack>
  );
};
